<div class="wrapper" [ngClass]="{ highlighted: highlighted, dimmed: dimmed || (configurable && !toggleOn), fitContent: fitContent }">
  <div class="header">
    <div class="titles">
      <icon *ngIf="!!titleIcon" [icon]="titleIcon" [i12]="true"></icon>
      <h3 [innerHTML]="title"></h3>
    </div>
    <ng-content></ng-content>
    <div style="flex:1"></div>
    <div class="status-holder" *ngIf="selected !== 'Off' && !dimmed && (toggleOn || statusOn)">
      <strong>Status:</strong>
      <traffic-light-dropdown
        [colorObject]="colors"
        [selections]="statusOptions"
        [selected]="selected"
        (select)=toggleStatus.emit($event)
      ></traffic-light-dropdown>
    </div>
    <div class="toggle-holder" *ngIf="!configurable">
      <div class="toggle-text" [ngClass]="{selected: toggleOn}">{{ toggleStates[toggleOn ? 1 : 0] }}</div>
      <mat-slide-toggle [disabled]="disabled" [ngClass]="{selected: toggleOn}" (change)="toggle.emit(!toggleOn)" [checked]="toggleOn"></mat-slide-toggle>
    </div>
    <div class="configurable" *ngIf="configurable">
      <div class="secondary_link" (click)="openConfigurations.emit(true)">{{ configureLabel }}</div>
    </div>
  </div>
  <ng-content select=".body"></ng-content>
  <div class="sessions" *ngIf="sessions?.length">
    <h5>SESSIONS</h5>
    <div class="grey-text" *ngFor="let s of sessions">{{ s.title || 'Untitled session' }} | {{ s.subTitle }}</div>
  </div>
</div>